// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-start-panel__new-account__container {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: var( --grid-gap );
    grid-template-areas: "left left left left right right right right right right right right";
    background-color: var( --white-color );
    height: 100%;    
}

.signup-start-panel__new-account__left-col {
    grid-area: left;
    background-color: var( --primary-very-dark-color );
    height: 100vh;
}

.signup-start-panel__new-account__right-col {
    grid-column: 7 / 11;
    margin-top: calc( var( --space-x3 ) + var(--space-x2) );
}

.signup-start-panel__new-account__title {
    text-align: center;
    margin-bottom: calc( var( --space-x3 ) - var( --space-quarter ));
}

.signup-start-panel__new-account__methods__method {
    background: var( --white-color );
    border: 1.2px solid var( --primary-dark-color );
    box-sizing: border-box;
    border-radius: var( --space-and-half );
    display: flex;
    justify-content: center;
    margin-bottom: calc( var( --space ) + 2px );    
    font-family: var( --secondary-font ); 
    font-style: normal;
    font-weight: var( --font-medium); 
    font-size: calc( var( --space ) + 2px );
    line-height:  calc( var( --space ) + var( --space-quarter ) );
    text-transform: capitalize;
    letter-spacing: 0.04em;
    width: 100%;
}

.signup-start-panel__new-account__methods__method.phone {
    margin: 0 var(--space-half-quarter) 0 0;
}

.signup-start-panel__separator__container span {
    font-family: var( --secondary-font ); 
    font-style: normal;
    font-weight: normal;
    font-size: calc( var( --space ) -  1px );
    line-height: calc( var( --space ) + 2px );
    color: var( --black-color ); 
}

.signup-start-panel__new-account__methods__method__label {
    font-family: var( --secondary-font ); 
    font-style: normal;
    font-weight: var( --font-medium); 
    font-size: calc( var( --space ) + 2px );
    line-height: calc( var( --space ) + var( --space-quarter ) );
    letter-spacing: 0.04em;
    color: var( --black-color ); 
    text-transform: capitalize !important;
}

.signup-start-panel__new-account__methods__method .icon-email,
.signup-start-panel__new-account__methods__method .icon-phone {
    font-size: calc( var( --space ) + var( --space-quarter ));
    margin-right: var( --space-half-quarter );
}

.signup-start-panel__new-account__methods__method .icon-email {
    color: var( --black-color );    
}

.signup-start-panel__terms-conditions {
    color: var( --new-green-color ); 
    cursor: pointer;
}

.signup-start-panel__new-account__terms-conditions__text {
    margin-top: calc( var( --space-x2 ) + var( --space-half ));
    font-family: var( --secondary-font ); 
    font-style: normal;
    font-weight: normal;
    font-size: calc( var( --space ) + 2px );
    line-height: calc( var( --space ) + var( --space-quarter ) + 2px );
    letter-spacing: 0.0025em;

    color: var( --basic-gray-color );   
}

.signup-start-panel__apple-logo {
 width: calc( var( --space ) + 1px ); 
}

.signup-start-panel__new-account__methods__method__apple span {
    color: var( --white-color );
    text-transform: capitalize;
}

.signup-start-panel__new-account__methods__method__apple {
    background-color: var( --black-color);
}

.signup-start-panel__separator__container {
    display: flex;
    justify-content: space-between;
    align-items: center; 
    margin: var( --space-x2 ) 0;  
}

.signup-start-panel__separator {
    width: 50%;
    border-bottom: 1px solid var( --black-color ); 
    height: 0;
}

.signup-start-panel__separator:first-of-type {
    margin-right: var( --space-half-quarter );
}

.signup-start-panel__separator:last-of-type {
    margin-left: var( --space-half-quarter );
}

.signup-start-panel__new-account__methods__method span {
    text-transform: capitalize;
}


/* TODO START: FALTA FIGMA EN HOVER, FOCUS Y ACTIVE*/

.signup-start-panel__new-account__methods__method.secondary-button:focus {
    background-color: var(--disabled-sb-bg-color);
}

.signup-start-panel__new-account__methods__method.secondary-button:hover {
    background-color: var(--disabled-sb-bg-color);
    color: var( --black-color );
}

.signup-start-panel__new-account__methods__method.secondary-button:active {
    background-color: var(--disabled-sb-bg-color);
}

.signup-start-panel__new-account__methods__method.secondary-button.signup-start-panel__new-account__methods__method__apple {
    background-color: var( --black-color);
}

.signup-start-panel__new-account__methods__method.phone img {
    margin-right: var( --space-half-quarter );
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/signup-start-panel/SignUpStartPanelComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sCAAsC;IACtC,wBAAwB;IACxB,sBAAsB;IACtB,0FAA0F;IAC1F,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,kDAAkD;IAClD,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,uDAAuD;AAC3D;;AAEA;IACI,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;IACI,gCAAgC;IAChC,+CAA+C;IAC/C,sBAAsB;IACtB,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,2CAA2C;IAC3C,oCAAoC;IACpC,kBAAkB;IAClB,gCAAgC;IAChC,uCAAuC;IACvC,6DAA6D;IAC7D,0BAA0B;IAC1B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,wCAAwC;IACxC,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,gCAAgC;IAChC,uCAAuC;IACvC,4DAA4D;IAC5D,sBAAsB;IACtB,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;;IAEI,yDAAyD;IACzD,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,0DAA0D;IAC1D,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,kEAAkE;IAClE,wBAAwB;;IAExB,gCAAgC;AACpC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,6CAA6C;IAC7C,SAAS;AACb;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;;AAGA,oDAAoD;;AAEpD;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;IAC7C,2BAA2B;AAC/B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yCAAyC;AAC7C","sourcesContent":[".signup-start-panel__new-account__container {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-template-rows: auto;\n    gap: var( --grid-gap );\n    grid-template-areas: \"left left left left right right right right right right right right\";\n    background-color: var( --white-color );\n    height: 100%;    \n}\n\n.signup-start-panel__new-account__left-col {\n    grid-area: left;\n    background-color: var( --primary-very-dark-color );\n    height: 100vh;\n}\n\n.signup-start-panel__new-account__right-col {\n    grid-column: 7 / 11;\n    margin-top: calc( var( --space-x3 ) + var(--space-x2) );\n}\n\n.signup-start-panel__new-account__title {\n    text-align: center;\n    margin-bottom: calc( var( --space-x3 ) - var( --space-quarter ));\n}\n\n.signup-start-panel__new-account__methods__method {\n    background: var( --white-color );\n    border: 1.2px solid var( --primary-dark-color );\n    box-sizing: border-box;\n    border-radius: var( --space-and-half );\n    display: flex;\n    justify-content: center;\n    margin-bottom: calc( var( --space ) + 2px );    \n    font-family: var( --secondary-font ); \n    font-style: normal;\n    font-weight: var( --font-medium); \n    font-size: calc( var( --space ) + 2px );\n    line-height:  calc( var( --space ) + var( --space-quarter ) );\n    text-transform: capitalize;\n    letter-spacing: 0.04em;\n    width: 100%;\n}\n\n.signup-start-panel__new-account__methods__method.phone {\n    margin: 0 var(--space-half-quarter) 0 0;\n}\n\n.signup-start-panel__separator__container span {\n    font-family: var( --secondary-font ); \n    font-style: normal;\n    font-weight: normal;\n    font-size: calc( var( --space ) -  1px );\n    line-height: calc( var( --space ) + 2px );\n    color: var( --black-color ); \n}\n\n.signup-start-panel__new-account__methods__method__label {\n    font-family: var( --secondary-font ); \n    font-style: normal;\n    font-weight: var( --font-medium); \n    font-size: calc( var( --space ) + 2px );\n    line-height: calc( var( --space ) + var( --space-quarter ) );\n    letter-spacing: 0.04em;\n    color: var( --black-color ); \n    text-transform: capitalize !important;\n}\n\n.signup-start-panel__new-account__methods__method .icon-email,\n.signup-start-panel__new-account__methods__method .icon-phone {\n    font-size: calc( var( --space ) + var( --space-quarter ));\n    margin-right: var( --space-half-quarter );\n}\n\n.signup-start-panel__new-account__methods__method .icon-email {\n    color: var( --black-color );    \n}\n\n.signup-start-panel__terms-conditions {\n    color: var( --new-green-color ); \n    cursor: pointer;\n}\n\n.signup-start-panel__new-account__terms-conditions__text {\n    margin-top: calc( var( --space-x2 ) + var( --space-half ));\n    font-family: var( --secondary-font ); \n    font-style: normal;\n    font-weight: normal;\n    font-size: calc( var( --space ) + 2px );\n    line-height: calc( var( --space ) + var( --space-quarter ) + 2px );\n    letter-spacing: 0.0025em;\n\n    color: var( --basic-gray-color );   \n}\n\n.signup-start-panel__apple-logo {\n width: calc( var( --space ) + 1px ); \n}\n\n.signup-start-panel__new-account__methods__method__apple span {\n    color: var( --white-color );\n    text-transform: capitalize;\n}\n\n.signup-start-panel__new-account__methods__method__apple {\n    background-color: var( --black-color);\n}\n\n.signup-start-panel__separator__container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; \n    margin: var( --space-x2 ) 0;  \n}\n\n.signup-start-panel__separator {\n    width: 50%;\n    border-bottom: 1px solid var( --black-color ); \n    height: 0;\n}\n\n.signup-start-panel__separator:first-of-type {\n    margin-right: var( --space-half-quarter );\n}\n\n.signup-start-panel__separator:last-of-type {\n    margin-left: var( --space-half-quarter );\n}\n\n.signup-start-panel__new-account__methods__method span {\n    text-transform: capitalize;\n}\n\n\n/* TODO START: FALTA FIGMA EN HOVER, FOCUS Y ACTIVE*/\n\n.signup-start-panel__new-account__methods__method.secondary-button:focus {\n    background-color: var(--disabled-sb-bg-color);\n}\n\n.signup-start-panel__new-account__methods__method.secondary-button:hover {\n    background-color: var(--disabled-sb-bg-color);\n    color: var( --black-color );\n}\n\n.signup-start-panel__new-account__methods__method.secondary-button:active {\n    background-color: var(--disabled-sb-bg-color);\n}\n\n.signup-start-panel__new-account__methods__method.secondary-button.signup-start-panel__new-account__methods__method__apple {\n    background-color: var( --black-color);\n}\n\n.signup-start-panel__new-account__methods__method.phone img {\n    margin-right: var( --space-half-quarter );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
